// Words that keep special casing when a label is built from a code.
const ACRONYMS = new Set(['DXA', 'QC']);
const LOWERCASE_WORDS = new Set(['TO', 'OF', 'AND', 'THE', 'FOR']);

// Build a readable label from a backend businessProcess code, e.g.
// DXA_UPLOAD_TO_WORKSTATION -> "DXA Upload to Workstation".
export const formatBusinessProcess = (code?: string) => {
  if (!code) return code;

  return code
    .split('_')
    .map((word, index) => {
      if (ACRONYMS.has(word)) return word;

      if (index > 0 && LOWERCASE_WORDS.has(word)) return word.toLowerCase();

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

export const toBusinessProcessOption = (code: string) => ({
  key: code,
  value: code,
  label: formatBusinessProcess(code) ?? code,
});
